var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable } from 'mobx';
import { ScheduledTask } from './ScheduledTask';
export class RuntimeSchedule {
    parent;
    isProcessBatchTriggered = false;
    pendingTasks = [];
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get runtime() {
        return this.parent;
    }
    addTask(actionFunc, options) {
        if (options.skipIfContains) {
            if (this.pendingTasks.find(task => task.skipIfContains === options.skipIfContains)) {
                return;
            }
        }
        const task = new ScheduledTask({ action: actionFunc, ...options });
        this.pendingTasks.push(task);
        return task;
    }
    processCurrentBatch() {
        const todos = this.pendingTasks.slice();
        this.pendingTasks = [];
        this.isProcessBatchTriggered = false;
        for (const task of todos) {
            task.resolve(task.action());
        }
    }
}
__decorate([
    action.bound
], RuntimeSchedule.prototype, "processCurrentBatch", null);
